module.exports = __webpack_public_path__ + "imgs/gazprom_partner.2aafa91e.webp";